'use client'

import React from "react"
import {Swiper,SwiperSlide} from "swiper/react"

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import Hashids from "hashids";

import { Pagination,Navigation } from 'swiper/modules';
import { useGlobalContext } from "@/app/component/context/provider";
import Link from "next/link";
import Image from "next/image";

const BookSlideSetD = ({data}) => {
    
    const { privateKey } = useGlobalContext()

    const Alldata = data[0]

    // console.log(Alldata.column_book);

    return(
        <>
            <div className="relative mx-0 md:mx-[5%] xl:mx-0 my-10 "> 
                <Swiper  
                    slidesPerView={1}  
                    spaceBetween={16} className="" 
                    modules={[Navigation,Pagination]}  
                    pagination={{
                        clickable: true, 
                        type: 'bullets',
                    }}
                  >
                    {Alldata.column_book
                    ?.slice() 
                    .sort((a, b) => {
                        if (a?.sort_order != null && b?.sort_order != null) {
                            return a.sort_order - b.sort_order
                        }
                        const orderA = Array.isArray(a?.order_id) ? (a.order_id[0]?.order ?? 0) : 0
                        const orderB = Array.isArray(b?.order_id) ? (b.order_id[0]?.order ?? 0) : 0
                        return orderA - orderB
                    })
                    .map((data, i) => {
                        let url = '';
                        switch (data.type) {
                            case 'link':
                                url = data.data_val;
                            break;
                            case 'serie':
                                const hashids = new Hashids(privateKey,6)
                                const encodedID = hashids.encode(data.data_val)
                                url = data.data_val ? `/ebook/${encodedID}` : '';
                            break;
                            default:
                            break;
                        } 
                        
                        return (
                            <SwiperSlide key={i}>
                            <div className="relative w-full aspect-[13.22/2] overflow-hidden rounded-xl bg-gray-100 dark:bg-zinc-800">
                            <Link target="_blank" href={url} className="block w-full h-full">
                                {data.img && (
                                    <Image
                                        src={data.img}
                                        alt="ad"
                                        fill
                                        loading="lazy"
                                        decoding="async"
                                        sizes="(max-width: 1280px) 100vw, 1200px"
                                        className="object-cover object-center"
                                        onClick={url === '' ? (e) => e.preventDefault() : undefined}
                                    />
                                )}
                            </Link>
                            </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </>
    )
}

export default BookSlideSetD